import axios from 'axios';
import * as Config from '../../config';

const state = {
    allPosiciones: [],
    montoPremium: '0'
 };

 const getters = {
    getAllPosiciones: state => state.allPosiciones,
    getMontoPremium: state => state.montoPremium,
 }

const actions = {
    async fetchAllPosiciones({ commit }) {
        try {
            const response = await axios.get(Config.apiPath + 'publicidad/get-all-posicion');
            commit('SET_ALL_POSICIONES', response.data.posiciones);
        } catch (error) {
            console.error('Error obteniendo posiciones:', error.response);
            throw error;
        }
    },
    async fetchMontoPremium({ commit }) {
        try {
            const response = await axios.get(Config.apiPath + 'publicidad/get-monto-premium');
            commit('SET_MONTO_PREMIUM', response.data.montoPremium);
        } catch (error) {
            console.error('Error obteniendo posiciones:', error.response);
            throw error;
        }
    },
    // Acción para almacenar un video
    publicidad_storeVideo({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'publicidad/store-video', form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    // Acción para obtener todos los videos
    publicidad_getAll() {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'publicidad/get-all')
                .then(response => {
                    resolve(response);  // Devuelve la respuesta directamente
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    // Acción para obtener un solo video por ID
    publicidad_get({ commit }, id) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'publicidad/get/' + id, { responseType: 'blob' })
                .then(response => {
                    // Extraer el tipo MIME de los encabezados de la respuesta
                    const mimeType = response.headers['content-type'];
                    
                    // Enviar tanto el blob como el mimeType
                    resolve({
                        data: response.data,  // El contenido binario (video) como un blob
                        mimeType: mimeType    // El tipo MIME del archivo
                    });
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    publicidad_getByPosicion({ commit }, posicion) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'publicidad/get-by-posicion?posicion=' + posicion, { responseType: 'blob' })
                .then(response => {
                    // Extraer el tipo MIME de los encabezados de la respuesta
                    const mimeType = response.headers['content-type'];
                    
                    // Enviar tanto el blob como el mimeType
                    resolve({
                        data: response.data,  // El contenido binario (video) como un blob
                        mimeType: mimeType    // El tipo MIME del archivo
                    });
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    publicidad_getAllPosicion() {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'publicidad/get-all-posicion')
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    publicidad_updatePosicion(commit, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'publicidad/update-posicion', form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    publicidad_getAllClients() {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'publicidad/get-all-clients')
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    publicidad_updateClient(commit, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'publicidad/update-client', form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    publicidad_updateCbu(commit, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'publicidad/update-cbu', form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    publicidad_getUpdateContdownClient(commit, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'publicidad/get-update-contdown-client', form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    publicidad_getMontoPremium() {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'publicidad/monto-premium')
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    publicidad_updatePremium(commit, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'publicidad/update-premium', form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    publicidad_updatePremiumPaga(commit, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'publicidad/update-premium-paga', form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    publicidad_verifyPremiumContdown(commit, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'publicidad/verify-premium-contdown', form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },

    publicidad_updateMetodoPago(commit, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'publicidad/update-metodo-pago', form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    
};

const mutations = { 
    SET_ALL_POSICIONES(state, posiciones) {
        state.allPosiciones = posiciones;
    },
    SET_MONTO_PREMIUM(state, montoPremium) {
        state.montoPremium = montoPremium;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
